import {adminHttpClient} from "../commons/adminHttpClient";


const deleteNotes = (id : string) : Promise<any> => {
    return adminHttpClient.delete(`/Notes/Delete`, {
        data:{id : id}
    })
}

export default deleteNotes;